import React, {useState, useContext} from 'react';
import { GrUserExpert, GrUser, GrTag } from "react-icons/gr";
import { BiReceipt } from "react-icons/bi";
import { Button, Dropdown, Container, Row, Col, Card, Modal, Spinner, Form } from 'react-bootstrap';
import Menu from "../components/Menu";
import { UserContext } from "../context/UserContext";
import { StatusService } from "../services/status-service";
import { FiPieChart} from "react-icons/fi";
import {HistoryWidget} from "../styles";

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

import Chart, {
  ArgumentAxis,
  Series,
  Legend,
  Subtitle,
  Label,
  Title,
  Tooltip,
  CommonSeriesSettings,
  CommonAxisSettings,
  Grid,
  Margin,
  Format
} from 'devextreme-react/chart';

import PieChart from 'devextreme-react/pie-chart';

import {HomePage, HomeBody, HomeContent} from "../styles";

import Toast from 'light-toast';

const periods = [
  {
    id: "week",
    name: "Semana actual"
  },{
    id: "mid_month",
    name: "Quinze dias"
  },{
    id: "month",
    name: "Mês actual"
  },{
    id: "trimester",
    name: "Três meses"
  },{
    id: "year",
    name: "Ano actual"
  },{
    id: "choose",
    name: "Personalizada"
  }
];

const periods_day = [
  {
    id: "all_day",
    name: "Todo o dia"
  },{
    id: "morning",
    name: "Manhã"
  },{
    id: "lunch",
    name: "Almoço"
  },{
    id: "afternoon",
    name: "Tarde"
  },{
    id: "dinner",
    name: "Jantar"
  },{
    id: "night",
    name: "Noite"
  },
];

const views = [
  {
    id: "general",
    name: "Visão Geral"
  },{
    id: "week",
    name: "Visão Semanal"
  },
];
let rp = 0;
function Stats() {
  const [user] = useContext(UserContext);
  const [load, setLoad] = useState(false);
  const [dateModal, setDateModal] = useState(false);
  const [dates, setDates] = useState({
    start: "",
    end: ""
  });

  const [s_period, setPeriod] = useState(periods[0]);
  const [s_period_day, setPeriodDay] = useState(periods_day[0]);
  const [s_view, setView] = useState(views[0]);

  const [discountsAndOffers, setDiscountsAndOffers] = useState(null);
  const [topBoard, setTopBoard] = useState({
    new_customers: 0,
    validated_customers: 0,
    offers: 0,
    total_amount: "0.00"
  });
  const [discountsAndOffersTotals, setDiscountsAndOffersTotals] = useState(null);
  const [architectureSources, setArchitectureSources] = useState(null);
  
  if(user.token && user.location_id && !discountsAndOffers && rp === 0) {
    rp++;
    getData(s_period.id, s_period_day.id, s_view.id, dates.start, dates.end);
  }

  async function getData(period = "trimester", period_time = "all_day", view="general", start_date = "", end_date = "") {
    try {
      setLoad(true);
      await StatusService.discountsAndOffers(user.token, user.location_id, period, start_date, end_date, period_time, view).then((result) => {
        if(result.data && result.setting) {
          setDiscountsAndOffers(result);
          rp=0;
        } else {
          const r = {
            data: [],
            setting: []
          };
          setDiscountsAndOffers(r);
        }
        setLoad(false);
      });
      await StatusService.topBoard(user.token, user.location_id, period, start_date, end_date, period_time, view).then((result) => {
        if(result) {
          setTopBoard(result);
        } else {
          setTopBoard({
            new_customers: 0,
            validated_customers: 0,
            offers: 0,
            total_amount: "0.00"
          });
        }
        setLoad(false);
      });
      await StatusService.discountsAndOffersTotals(user.token, user.location_id, period, start_date, end_date, period_time, view).then((result) => {
        if(result) {
          setDiscountsAndOffersTotals(result);
        } else {
          setDiscountsAndOffersTotals(null);
        }
        setLoad(false);
      });
      await StatusService.architectureSources(user.token, user.location_id, period, start_date, end_date, period_time, view).then((result) => {
        if(result.data && result.setting) {
          setArchitectureSources(result);
        } else {
          const r = {
            data: [],
            setting: []
          };
          setArchitectureSources(r);
        }
        setLoad(false);
      });
    } catch {
      setLoad(false);
      // Toast.fail('Ocorreu um erro.', 3000);
    }
  }

  function periodChange(item) {
      setPeriod(item);
      if(item.id === "choose") {
        setDateModal(true)
      } else {
        getData(item.id, s_period_day.id, s_view.id)
      }
  }

  function periodDayChange(item) {
      setPeriodDay(item);
      getData(s_period.id, item.id, s_view.id);
  }

  function viewChange(item) {
      setView(item);
      getData(s_period.id, s_period_day.id, item.id);
  }

  let periodItems = periods.map((item) => {
    return (
        <Dropdown.Item active={item.id === s_period.id ? true : false} key={item.id} onSelect={()=> periodChange(item)}>{item.name}</Dropdown.Item>
    )
  });

  let periodDayItems = periods_day.map((item) => {
    return (
        <Dropdown.Item active={item.id === s_period_day.id ? true : false} key={item.id} onSelect={()=> periodDayChange(item)}>{item.name}</Dropdown.Item>
    )
  });

  let viewsItems = views.map((item) => {
    return (
        <Dropdown.Item active={item.id === s_view.id ? true : false} key={item.id} onSelect={()=> viewChange(item)}>{item.name}</Dropdown.Item>
    )
  });

  function tooltipValue(arg) {
    let formated;
    if(arg.seriesName === "Com Desconto") {
      formated = discountsAndOffersTotals.find((e)=> {return e.comDesconto === arg.value}).formated_comDesconto;
    }
    return {
      text: `<b>Total:</b> ${ formated} Kz` 
    };
  }

  function tooltipUtilizacoes(arg) {
    const title = discountsAndOffers?.setting.find((s) => {return s.name === arg.seriesName}).title;
    return {
      text: `${title ? title : arg.seriesName }<br><b>Utilizações:</b> ${ arg.valueText}`
    };
  }

  function setDate() {
    var start_date = new Date(dates.start);
    var end_date = new Date(dates.end);
    if(start_date <= end_date) {
      getData(s_period.id, s_period_day.id, s_view.id, dates.start, dates.end);
    } else {
      setDates({start: "", end: ""});
      Toast.fail('Ordem de Data Inválida.', 3000);
    }
    
  }

  return (
      <HomePage>
        <Menu locations={true} page="stats" />
        <HomeContent>
        <div className="pageTitle"><FiPieChart/> ESTATÍSTICAS</div>
          <HomeBody className="stats pb-5">
          <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={load}
            onHide={() => setLoad(true)}
            className="trasnp"
          >
            <Modal.Body>
                <Spinner animation="border" role="status" style={{color:'white'}}>
                </Spinner>
                <span className="sr-only">Loading...</span>
            </Modal.Body>
          </Modal>

          <Modal 
            show={dateModal}
            centered
            size="sm"
            onHide={() => {setDateModal(false); }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Escolher as Datas</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <div className="_input">
                  <Form.Label>Data Início</Form.Label>
                  <Form.Control type="date" value={dates.start}
                  onChange={(e) => setDates({...dates, start: e.target.value})} />
                </div>
                <div className="_input">
                  <Form.Label>Data Fim</Form.Label>
                  <Form.Control type="date" value={dates.end}
                  onChange={(e) => setDates({...dates, end: e.target.value})} />
                </div>
              </div> 
            </Modal.Body>

            <Modal.Footer>
              <Button disabled={dates.start && dates.end ? false : true} variant="success" onClick={(e) => {setDateModal(false); setDate()}} style={{width: "100%"}}>Pesquisar</Button>
            </Modal.Footer>
          </Modal>

          <Container >
            <Row>
              <Col>
                <Card className="filter-card">
                  <Card.Body>
                    <h4 className="m-0 float-left">Selecione o periodo</h4>
                    <Dropdown>
                      <Dropdown.Toggle variant="danger" className="float-right">
                        {s_view.name}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {viewsItems}
                      </Dropdown.Menu>  
                    </Dropdown>
                    <Dropdown>
                      <Dropdown.Toggle variant="danger" className="float-right mr-2">
                        {s_period_day.name}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                      {periodDayItems}
                      </Dropdown.Menu>  
                    </Dropdown>
                    <Dropdown>
                      <Dropdown.Toggle variant="danger" className="float-right mr-2">
                      {s_period.name}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                      {periodItems}
                      </Dropdown.Menu>  
                    </Dropdown>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card className="mt-3">
                  <Card.Body>
                  <HistoryWidget>
                    <Row>
                        <Col className="item border-right">
                          <GrUser />
                          <div>
                            <h3>Novos Clientes</h3>
                            <div className="number">{topBoard.new_customers}</div>
                          </div>
                        </Col>
                        <Col className="item border-right">
                          <GrUserExpert />
                          <div>
                            <h3>Clientes validados</h3>
                            <div className="number">{topBoard.validated_customers}</div>
                          </div>
                        </Col>
                        <Col className="item border-right">
                          <GrTag />
                          <div>
                            <h3>Descontos e Ofertas</h3>
                            <div className="number">{topBoard.offers}</div>
                          </div>
                        </Col>
                        <Col className="item">
                          <BiReceipt />
                          <div>
                            <h3>Total Recebido</h3>
                            <div className="number small">{topBoard.total_amount} kz</div>
                          </div>
                        </Col>
                    </Row>
                    </HistoryWidget>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row className="row_discount">
              <Col>
                <Card className="mt-4">
                  <Card.Body>
                    <Chart
                      dataSource={discountsAndOffers?.data}
                      palette="Bright"
                    >
                      <Title text="Descontos e Ofertas" horizontalAlignment="left">
                        <Subtitle text="Número de utilizações" />
                      </Title>
                      <CommonSeriesSettings argumentField="label" type="stackedBar" />
                      {
                        discountsAndOffers?.setting.map((item, index) => {
                          return (
                            <Series
                              key={index}
                              valueField={item.value}
                              name={item.name}
                            />
                          )
                        })
                      }
                      
                      <Legend
                        verticalAlignment="top"
                        horizontalAlignment="right"
                      />
                      <Tooltip
                        enabled={true}
                        location="edge"
                        customizeTooltip={tooltipUtilizacoes}
                      />
                    </Chart>
                  </Card.Body>
                </Card>
              </Col> 
              <Col>
                <Card className="mt-4">
                  <Card.Body>
                    <PieChart
                      id="pie"
                      type="doughnut"
                      innerRadius={0.2}
                      palette="Bright"
                      dataSource={discountsAndOffersTotals}
                    >
                      <Title text="Valor Faturação por Período" horizontalAlignment="left">
                        <Subtitle text="Total em Kwanzas" />
                      </Title>
                      <CommonSeriesSettings>
                        <Label visible={false} />
                      </CommonSeriesSettings>
                      {/* <Series name="Sem Desconto" argumentField="name" valueField="semDesconto" /> */}
                      <Series name="Com Desconto" argumentField="name" valueField="comDesconto" />
                      <Legend
                        verticalAlignment="top"
                        horizontalAlignment="right" 
                      />
                      <Tooltip enabled={true} customizeTooltip={tooltipValue} />
                    </PieChart>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card className="mt-4">
                  <Card.Body>
                  <Chart
                    palette="Bright"
                    dataSource={architectureSources?.data}
                    title="Estatísticas Website"
                  >
                    <CommonSeriesSettings
                      argumentField="label"
                      type="spline"
                    />
                    <CommonAxisSettings>
                      <Grid visible={true} />
                    </CommonAxisSettings>
                    {
                      architectureSources?.setting.map(function(item, index) {
                        return (
                          <Series 
                            key={index} 
                            valueField={item.value} 
                            name={item.title} 
                          />
                        );
                      })
                    }
                    <Margin bottom={20} />
                    <ArgumentAxis
                      allowDecimals={false}
                      axisDivisionFactor={60}
                    >
                      <Label>
                        <Format type="decimal" />
                      </Label>
                    </ArgumentAxis>
                    <Legend
                      verticalAlignment="top"
                      horizontalAlignment="right"
                    />
                    <Tooltip enabled={true} />
                  </Chart>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
          </HomeBody>
        </HomeContent>
      </HomePage>
  );
}

export default Stats;

